import styled from 'styled-components'

import { variables } from 'src/Styled/variables'

export const StyledCheckbox = styled.div`
  .ant-checkbox-wrapper {
    display: flex;
  }

  .ant-checkbox-wrapper:hover {
    .ant-checkbox-inner {
      border: 1px solid ${({ theme }) => theme.color.darkGrey};
    }
    .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
      border: 1px solid ${({ theme }) => theme.color.darkGrey};
      background-color: ${({ theme }) => theme.color.white};
    }
  }

  .ant-checkbox .ant-checkbox-inner {
    width: 16px;
    height: 16px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.darkGrey};
    border-radius: 4px;
  }

  .ant-checkbox-checked .ant-checkbox-inner:after {
    border-color: ${({ theme }) => theme.color.brandGreen} !important;
    top: 45%;
  }

  .ant-checkbox-checked::after {
    border: transparent !important;
  }
  .ant-checkbox-disabled .ant-checkbox-inner {
    width: 16px;
    height: 16px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.darkGrey};
    border-radius: 4px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    width: 16px;
    height: 16px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.darkGrey};
    border-radius: 4px;
  }
`
export const Label = styled.span`
  font-size: ${variables.fontSize14};
  line-height: 21px;
  color: ${({ theme }) => theme.color.slateGrey};
`
